import {useAppSelector} from "@Hooks/selector/useAppSelector";
import useGetCheapestGbtVehicle
    from "@SearchResults/features/banners/features/getByTransferBanner/hooks/useGetCheapestGbtVehicle";
import useIsFerry from "@GetByFerry/hooks/useIsFerry";
import {TransfersDataType} from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersData.type";
import {
    GetByFerryDataType
} from "@SearchResults/features/banners/features/getByTransferBanner/types/GetByFerryData.type";
import {useMemo} from "react";
import TransfersVehicleType
    from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersVehicle.type";

interface UseGbtBannerReturnType {
    vehicles: TransfersVehicleType[],
    gbtShowBanner: boolean,
    gbtShowNoDirectRoutesNotification: boolean,
}

interface UseGetBannerAttributes {
    transfersData: TransfersDataType,
    getByFerryData: GetByFerryDataType,
    numberOfResults?: number,
}

/**
 * Returns everything transfer banner related
 */
export default function useGbtBanner(props: UseGetBannerAttributes): UseGbtBannerReturnType {
    const {
        transfersData,
        getByFerryData,
        numberOfResults,
    } = props

    const {
        maxRoutePrice,
    } = useAppSelector((state) => (state.filter))

    const {
        departureStationObject: {
            id: departureStationId,
        },
        destinationStationObject: {
            id: destinationStationId,
        },
    } = useAppSelector((state) => (state.form))

    const {
        vehicles,
        departureNearbyCity,
        destinationNearbyCity,
    } = transfersData || {}

    // SHOW NO DIRECT ROUTES NOTIFICATION IF
    // there are no routes and neither departure nor destination is a nearby city
    //
    // this is memoized as not to change once the departureStationId or destinationStationId is switched in search form,
    // but only to update once the transfersData is updated
    const gbtShowNoDirectRoutesNotification = useMemo(() => (
        numberOfResults === 0
        && destinationNearbyCity?.id !== `${departureStationId}`
        && departureNearbyCity?.id !== `${destinationStationId}`
    ), [transfersData, numberOfResults])

    return {
        vehicles,
        gbtShowBanner: true,
        gbtShowNoDirectRoutesNotification,
    }
}